import { effectiveFieldName } from './dataFieldBinding';

export function dataFieldWarning({ fieldName, fields, steps, isStep, editingId }) {
  if (!fieldName || !fields || !steps) return null;
  const selected = fields.find(field => field.fieldName === fieldName) ||
    fields.find(field => field.id === fieldName);
  const effectiveName = selected?.fieldName || fieldName;
  const writers = steps.filter(step => {
    if (isStep && step.id === editingId) return false;
    const output = effectiveFieldName(step, fields, true);
    return output === effectiveName;
  });
  if (isStep && writers.length) {
    return {
      type: 'error',
      message: `Warning: Step "${writers[0].displayName || writers[0].name || writers[0].id}" already writes to "${effectiveName}". Multiple writers may cause conflicts.`,
    };
  }
  if (!isStep && !writers.length) {
    return {
      type: 'warning',
      message: `Note: No step currently writes to "${effectiveName}". This section may not receive data.`,
    };
  }
  return null;
}
